export enum HttpHeaders {
  TENANT_SUB_DOMAIN = 'tenant-sub-domain',
  TENANT_ID = 'tenant-id',
  CORRELATION_ID = 'correlation-id',
  AUTHORIZATION = 'Authorization',
  CONTENT_TYPE = 'Content-Type',
}
